
/**
 * Service for retrieving test points for Level 2 tests
 */

/**
 * Get test points for Level 2 tests
 */
export const getTestPoints = (testId: string): string[] => {
  console.log("Level2Service.getTestPoints called for:", testId);
  console.log("getTestPoints - pathname:", window.location.pathname);
  console.log("getTestPoints - isLevel1:", window.location.pathname.includes('level1'));
  console.log("getTestPoints - isLevel2:", window.location.pathname.includes('level2'));
  
  // Special handling for bunker tests - LEVEL 2
  if (testId === "bunker-court") {
    return ["D", "E", "F"];
  } else if (testId === "bunker-long") {
    return ["D1", "E1"];
  }
  
  // Special handling for wedging tests - LEVEL 2
  if (testId === "wedging-cercles") {
    return ["D", "E", "F"];
  } else if (testId === "wedging-mid") {
    return ["D1", "E1", "F1"];
  } else if (testId === "wedging-pente-gauche") {
    return ["D2", "E2", "F2"];
  }
  
  // Special handling for chipping tests - LEVEL 2
  if (testId === "chipping-plat") {
    return ["D", "E", "F"];
  } else if (testId === "chipping-pente-droit") {
    return ["D1", "E1", "F1"];
  } else if (testId === "chipping-pente-gauche") {
    return ["D2", "E2", "F2"];
  } else if (testId === "chipping-roulee-plat") {
    return ["D3", "E3", "F3"];
  }
  
  // For putting tests
  if (testId === "putts-plat") {
    return ["D", "E", "F"];
  } else if (testId === "putts-montee") {
    return ["D1", "E1", "F1"];
  } else if (testId === "putts-descente") {
    return ["D2", "E2", "F2"];
  } else if (testId === "putts-pente") {
    return ["D3", "E3", "F3"];
  } else if (testId === "putts-pente-droite") {
    return ["D4", "E4", "F4"];
  }
  
  // Specific to iron tests
  if (testId === "iron-long" || testId === "iron-mid") {
    return ["D"];
  } else if (testId === "iron-green-attack-100") {
    return ["D"];
  }
  
  // Specific to fairway wood tests
  if (testId === "fairwayWood-3" || testId === "fairwayWood-5") {
    return ["D"];
  }
  
  // Specific to driver tests
  if (testId === "driver-practice" || testId === "driver-accuracy") {
    return ["D"];
  }
  
  // For other tests, use the default points
  return ["D", "E", "F"];
};
